/**
 * Helper function to convert "never" (0) to Infinity for duration comparison
 * This allows proper comparison between "never" and finite durations
 */
export const toDurationForComparison = (seconds: number): number => {
    return seconds === 0 ? Infinity : seconds;
};

/**
 * Helper function to check if org policy is more restrictive than user preference
 * A policy is more restrictive if it has a shorter duration (closer to immediate deletion)
 */
export const isOrgPolicyMoreRestrictive = (orgPolicySeconds: number, userPreferenceSeconds: number): boolean => {
    const orgPolicyDuration = toDurationForComparison(orgPolicySeconds);
    const userPreferenceDuration = toDurationForComparison(userPreferenceSeconds);
    return orgPolicyDuration < userPreferenceDuration;
};

/**
 * Parse stored previous org policy value from string to number
 * Returns undefined if no previous value was stored (first visit)
 */
export const parsePreviousOrgPolicyValue = (value: string | undefined): number | undefined => {
    if (typeof value !== "string") {
        return undefined; // First visit - no previous value stored
    }

    const parsed = parseInt(value, 10);
    if (isNaN(parsed)) {
        return undefined; // Invalid stored value - treat as first visit
    }

    return parsed;
};
